import HeaderBar from './HeaderBar.vue'

export default HeaderBar
